
import React, { useState, useEffect } from 'react';
import WinXP from 'WinXP';
import TerminalLoader from './TerminalLoader';

import xpBackground from 'assets/bliss.png';
const ASSETS_TO_PRELOAD = [
  xpBackground,
];
const App = () => {
  // Initialize state based on whether the document is already fully loaded
 const [isFullyLoaded, setIsFullyLoaded] = useState(false);

  useEffect(() => {
    // Helper to load a single image
    const preloadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = resolve;
        img.onerror = resolve; // Always resolve so bad links don't break the app
      });
    };

    // Wait for all assets in the array to download
    Promise.all(ASSETS_TO_PRELOAD.map((src) => preloadImage(src)))
      .then(() => {
        setIsFullyLoaded(true);
      });
      
  }, []);

  // Show terminal while downloading
  if (!isFullyLoaded) {
    return <TerminalLoader />;
  }

  return <WinXP />;;
};


export default App;
